import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useExtraTool } from "@/contexts/ExtraToolContext";
import {
  ChronometerIcon,
  MinusIcon,
  PlayIcon,
  Plus2Icon,
  RefreshIcon,
  Timer2Icon,
  TwoDotIcon,
  SquareIcon,
  TimesIcon,
} from "@/icons";
import "./index.scss";
import Draggable from "react-draggable";

const StopWatch = () => {
  const { t } = useTranslation("translation", { keyPrefix: "footer" });
  const { isStopWatchOpen, closeStopWatch } = useExtraTool();

  const [time, setTime] = useState<number>(0); // Zaman değerini temsil eder
  const [ticker, setTicker] = useState<{
    state: boolean;
    ticker: NodeJS.Timeout | null;
  }>({
    state: false,
    ticker: null,
  });
  const [isStopWatch, setIsStopWatch] = useState<boolean>(false); // Kronometre mi yoksa geri sayım mı kontrolü
  const nodeRef = React.useRef<HTMLDivElement>(document.createElement("div"));

  const h = Math.floor(time / (60 * 60)),
    m = Math.floor(time / 60) % 60,
    s = time % 60;

  function displayUnit(unit: number): string {
    return unit === 0 ? "00" : unit < 10 ? `0${unit}` : unit.toString();
  }

  useEffect(() => {
    clearInterval(ticker.ticker as NodeJS.Timeout);
    setTicker({ ...ticker, state: false });
    setTime(0);
  }, [isStopWatch]);

  const stopTimer = () => {
    clearInterval(ticker.ticker as NodeJS.Timeout);
  };

  const startStopTimer = () => {
    let time2 = time;
    if (ticker.state) {
      clearInterval(ticker.ticker as NodeJS.Timeout);
      setTicker({ ...ticker, state: false });
    } else {
      const t = setInterval(() => {
        if (!isStopWatch) {
          if (time2 >= 1) {
            time2 -= 1;
            setTime(time2);
          } else {
            stopTimer();
          }
        } else {
          time2 += 1;
          setTime(time2);
        }
      }, 1000);
      setTicker({ state: true, ticker: t });
    }
  };

  const resetTime = () => {
    clearInterval(ticker.ticker as NodeJS.Timeout);
    setTicker({ ...ticker, state: false });
    setTime(0);
  };

  const upTime = () => {
    stopTimer();
    let time2 = time;
    if (time2 < 99 * 60 * 60 + 59 * 60) time2 += 60;
    setTime(time2);
  };

  const downTime = () => {
    stopTimer();
    let time2 = time;
    if (time2 >= 60) time2 -= 60;
    setTime(time2);
  };

  return (
    <>
      {isStopWatchOpen && (
        <Draggable cancel=".close-button, .countdown" nodeRef={nodeRef}>
          <div
            ref={nodeRef}
            className={`modal open withoutOverlay`}
            style={{
              top: "30%",
              left: "30%",
              transform: "translate(-50%, -50%) !important",
              position: "absolute",
            }}
          >
            <div className="modal-header">
              <button className="close-button" onClick={() => closeStopWatch()}>
                <TimesIcon className={undefined} />
              </button>
            </div>
            <div className="countdown">
              <div className="display-wraper">
                <div className="flex justify-content-center margin-bottom-10 margin-top-10">
                  <button
                    className="count-down-btn btn-cancel-drag"
                    onClick={resetTime}
                  >
                    <RefreshIcon className={undefined} />
                  </button>
                  {!isStopWatch && (
                    <button
                      className="count-down-btn btn-cancel-drag"
                      onClick={upTime}
                      disabled={ticker.state}
                    >
                      <Plus2Icon className={undefined} />
                    </button>
                  )}

                  <span className="countertext">
                    <span className="value">{displayUnit(m)}</span>
                    <TwoDotIcon />
                    <span className="value">{displayUnit(s)}</span>
                  </span>
                  {!isStopWatch && (
                    <button
                      className="count-down-btn btn-cancel-drag"
                      onClick={downTime}
                      disabled={ticker.state}
                    >
                      <MinusIcon className={undefined} />
                    </button>
                  )}

                  <button
                    className="count-down-btn btn-cancel-drag"
                    onClick={startStopTimer}
                  >
                    {ticker.state ? (
                      <SquareIcon />
                    ) : (
                      <PlayIcon className={undefined} />
                    )}
                  </button>
                </div>
                <div
                  className="flex justify-content-center"
                  style={{ justifyContent: "center" }}
                >
                  <button
                    className={`obro-btn obro-light-gray-btn w-50 ${
                      isStopWatch ? "active" : ""
                    }`}
                    onClick={() => setIsStopWatch(!isStopWatch)}
                  >
                    <ChronometerIcon className={undefined} color={undefined} />{" "}
                    {t("stopwatch")}
                  </button>
                  <button
                    className={`obro-btn obro-light-gray-btn w-50 ${
                      !isStopWatch ? "active" : ""
                    }`}
                    onClick={() => setIsStopWatch(!isStopWatch)}
                  >
                    <Timer2Icon className={undefined} color={undefined} />{" "}
                    {t("timer")}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Draggable>
      )}
    </>
  );
};

export default StopWatch;
